import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function UpdatedDateIcon() {
  return (
    <SvgIcon
      viewBox="-2 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.09814 1L3.09814 2L2.09814 2C0.993575 2 0.0981444 2.89543 0.0981445 4L0.0981448 16C0.0981442 17.1046 0.993576 18 2.09815 18L7.67966 18C7.42436 17.3693 7.24716 16.6986 7.16004 16H2.09814L2.09814 7L14.0981 7L14.0981 7.06189C14.4257 7.02104 14.7595 7 15.0981 7C15.4368 7 15.7706 7.02104 16.0981 7.06189V4C16.0981 2.89543 15.2027 2 14.0981 2L13.0981 2L13.0981 1C13.0981 0.447715 12.6504 7.93975e-09 12.0981 6.17074e-08C11.5459 1.06137e-07 11.0981 0.447715 11.0981 1L11.0981 2H5.09814V1C5.09814 0.447715 4.65043 -1.97767e-08 4.09814 0C3.54586 1.34924e-07 3.09814 0.447715 3.09814 1Z"
        fill="currentColor"
      />
      <path
        d="M11.7235 12.682C12.6603 11.3418 14.3676 10.6626 16.0384 11.1103C16.9095 11.3437 17.6338 11.8455 18.1495 12.5037L19.7238 11.2701C18.95 10.2826 17.8599 9.52783 16.556 9.17847C13.9727 8.48627 11.3312 9.59006 9.95735 11.7244L9.36365 9.89734L7.46155 10.5154L9.1234 15.6298L14.1021 14.0121L13.4841 12.11L11.7235 12.682Z"
        fill="currentColor"
      />
      <path
        d="M20.9666 19.6147L20.3464 17.7061C19.0871 20.175 16.2349 21.5157 13.4502 20.7696C12.1466 20.4203 11.0566 19.6657 10.2829 18.6785L11.857 17.4447C12.3727 18.1027 13.0969 18.6044 13.9678 18.8377C15.8024 19.3293 17.6809 18.4622 18.5352 16.8533L16.8462 17.4021L16.2282 15.5L21.2068 13.8823L22.8687 18.9967L20.9666 19.6147Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
